import type { FaireProductEntity } from "../../entity_types/product";

export const p_4p3crhw8vr: FaireProductEntity = {
  token: "p_4p3crhw8vr",
  type: "product",
  name: "Natural Stone Beads Single Strand Necklace",
  brandToken: "b_eow5j1bbc8",
  brandName: "Ellison+Young",
  imageUrl:
    "https://cdn.faire.com/fastly/cf6e45917e57fb2545acf3e8fbd2cb8dab43a5c841ac2bb7761ff0206008ab0b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9856fc21ae4d8f0480c1a3c466252cf54e7fb7cd40c27007d9399b12909fb2e0.png",
    "https://cdn.faire.com/fastly/ea677d222c6ede5d0fcbc06e6ce96ed40fd3aea037bc3b82a792146680928dc1.png",
    "https://cdn.faire.com/fastly/cdb9ffc7a81c00003d7ccf52e897da0aa2ee28c1caefc671693f30b67b447bcc.png",
    "https://cdn.faire.com/fastly/ed16df28bfcbc153c4ac7c7641fe1bcd128a5cd59e22ef9e2c2ac3e557e1944a.png",
    "https://cdn.faire.com/fastly/2d960edc73d497f53681fc39451116c222e32e9be5b9d1faeac6d0dbe7896463.png",
    "https://cdn.faire.com/fastly/d4edbf90232f483b1cadab6bf89fb5c1e10e9af33f26d2adb88a0c29e9aed324.png",
    "https://cdn.faire.com/fastly/f3d97bad35af2eae908940953a0cf26058054d941a0bb0d86765633be3f9a07a.png",
    "https://cdn.faire.com/fastly/68d6ca075f6f8aa057087a67f89b0036627a24cb92d8ded0053e7faa5d55b0ef.png",
    "https://cdn.faire.com/fastly/6a8b170f7a5993a2c7a7e31bc4a740850e5ce7db467b018ae8602dd1e510e8cb.png",
    "https://cdn.faire.com/fastly/867e9e428c6ad00af710de64c64aa3e96f4c9b24fdbe98751df468499922e812.png",
    "https://cdn.faire.com/fastly/263808738b497281f69dd5c9ca48c614805bd8b9a1c28456f227f4bbfd3837b8.png",
    "https://cdn.faire.com/fastly/33f73e4ca128c44d858f4b278956d88ef4ab6ecccd3bec02447d6338c89c5de8.jpeg",
    "https://cdn.faire.com/fastly/dca7732c46851994235a39da8e7db754d88d53f1b01e9b7d7184afa3689044c1.png",
  ],
  priceDollars: 6.5,
  description:
    'Simple yet striking, the Natural Stone Beads Single Strand Necklace brings earthy elegance to your look. Featuring a single strand of natural stone beads, this necklace highlights organic beauty with a touch of modern sophistication, perfect for everyday wear or special occasions.\n\n• Natural Stone Design – Unique textures and tones for an earthy charm. Each piece may have slight color and size difference due to the characteristics of natural stone beads.\n• Minimalist Strand – Timeless simplicity that pairs with any outfit.\n• Versatile Styling – Wear solo or layer with other necklaces\n\nDimensions: Approximately 15" with 2" extender\nMaterials: Natural stones, 18K real gold plated brass for a beautiful, rich tone\nFeatures: Hypoallergenic, lead & nickel free, made for long-lasting shine\nImported',
  tags: [],
  msrpDollars: 16.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:25.170Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
